/** All dates are ISO calendar dates (YYYY-MM-DD) in Perth local time; arithmetic is done in UTC to avoid DST/offset drift. */
const toUtc = (iso) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(iso))
        throw new Error(`Invalid ISO date: ${iso}`);
    return new Date(`${iso}T00:00:00Z`);
};
const fromUtc = (d) => d.toISOString().slice(0, 10);
export function addDays(iso, n) {
    const d = toUtc(iso);
    d.setUTCDate(d.getUTCDate() + n);
    return fromUtc(d);
}
export function isNonWorkingDay(iso, holidays = new Set()) {
    const dow = toUtc(iso).getUTCDay();
    return dow === 0 || dow === 6 || holidays.has(iso);
}
/**
 * Due date for a task offset from an anchor date.
 * smart: tasks before (or on) the anchor move earlier, tasks after it move later.
 */
export function dueDate(anchorIso, offsetDays, rule, holidays = new Set()) {
    let d = addDays(anchorIso, offsetDays);
    if (rule === 'none')
        return d;
    const step = rule === 'prev' ? -1 : rule === 'next' ? 1 : offsetDays > 0 ? 1 : -1;
    let guard = 0;
    while (isNonWorkingDay(d, holidays)) {
        d = addDays(d, step);
        if (++guard > 14)
            throw new Error('Could not find a working day within 14 days');
    }
    return d;
}
export function daysBetween(fromIso, toIso) {
    return Math.round((toUtc(toIso).getTime() - toUtc(fromIso).getTime()) / 86_400_000);
}
/** Today's date in Perth (UTC+8, no daylight saving). */
export function todayPerth(now = new Date()) {
    return fromUtc(new Date(now.getTime() + 8 * 3_600_000));
}
//# sourceMappingURL=dates.js.map